// CANONICAL COPY (GH #7115). src/constants/obligations/obl-training-deadline-compliance.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-training-deadline-compliance',
  title: 'Training completed before assigned deadlines',
  description:
    'When training courses carry assignment deadlines, every assigned active employee must pass the course before the deadline. Vacuously satisfied when no active courses exist, or when no past-deadline assignments have incomplete employees. Link this obligation to a standing decision on a Security Awareness Training risk: the governance sweeper will automatically flip that risk to reassessment-required whenever a deadline lapses without completion.',
  category: 'people',
  scfIds: ['SCF-PPL-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'training-deadline-overdue',
      description:
        'No active training course has a past assignment deadline with one or more incomplete assigned employees',
    },
  ],
  domainActions: [{ type: 'deep-link', target: 'employees', label: 'Review Training Status' }],
};
